import { CoberturaZurich } from "./cotizacion-zurich-res.model";

export class CotizacionZurich {
    plataforma: string = 'Unknown'
    moneda: string = '00000000';
    descuento: string = '';
    recargos: string = '';
    vigenciaDe: string = '';
    vigenciaA: string = '';
    negocioID: number = 0;
    paqueteID: number = 0;
    contratante: ContratanteZurich = new ContratanteZurich();
    ubicacion: UbicacionZurich = new UbicacionZurich();
    coberturas: Array<CoberturaZurich> = new Array<CoberturaZurich>();
    cia: number = 0;
    grupoEstructuraID: number = 0;
    cat: boolean = false;
    formaPago: number = 0;
    claveActividad?: string = "";
}

export class ContratanteZurich {
    tipoPersona: string = 'F';
    nombre: string = '';
    apPaterno: string = '';
    apMaterno: string = '';
    rfc: string = '';
    fechaNacimiento: string = '2000-01-01';
    edoCivil: string = '';
    nacionalidad: string = '00000046';
    sexo: string = 'M';
    edad: number = 18;
    telefono: string = "";
    correo: string = "";
    tipoIde: string = '0';
    numIdentificacion: string = '';
    direccion: DireccionZurich = new DireccionZurich();
}

export class UbicacionZurich {
    cveEquipoSeg: string = '';
    anioConstruccion: number = 0;
    numPisos: number = 0;
    numNiveles: number = 0;
    cveMuro: string = '';
    cveTecho: string = '';
    cveEntrepiso: string = '';
    cveEstructura: string = '';
    duenio: number = 0;
    construccion: number = 0;
    terreno: number = 0;
    tipoInmueble: string = '';
    claseInmueble: string = '';
    direccion: DireccionZurich = new DireccionZurich();
    proteccion: boolean = false;
    alarmaLocal: boolean = false;
    alarmaCentral: boolean = false;
    accesoControlado: boolean = false;
    cercaniaCuerpoAgua: number = 0;
    valorInmueble: number = 0;
    valorContenidos: number = 0;
    giro: string = "0";
    subGiro: string = "";
    claveActividad: string = "";
}

export class DireccionZurich {
    calle: string = '';
    noExt: string = '';
    noInt: string = '';
    cp: string = '';
    estadoID: number = 0;
    municipioID: number = 0;
    colonia: string = '';
    consecutivoCol?: number;
    consecutivo?: number;
    municipio: string = "";
    estado: string = "";
}